module.exports = __webpack_public_path__ + "static/media/click-add-pyvs.9a233327.gif";